import React from "react";
import { FormattedMessage } from "react-intl";

interface ShowMoreButtonProps {
  itemId: string | undefined;
  onRefetchData: () => void;
  isLoading?: boolean;
}

const ShowMoreButton = ({itemId, onRefetchData, isLoading = false}: ShowMoreButtonProps) => {
  return (
    <div className={`show-more-button ${itemId ? "show-more-button-detail" : ""}`}>
      <button className="button button-secondary" onClick={onRefetchData}>
        {isLoading ? (
          <FormattedMessage id="Loading" defaultMessage="Loading..." />
        ) : (
          <FormattedMessage id="ShowMore" defaultMessage="Show more" />
        )}
      </button>
    </div>
  );
};

export default ShowMoreButton;